import { ChangePasswordMessages, TranslationChangePasswordMessages } from "@languages/interfaces";

export const messages: TranslationChangePasswordMessages = {
  [ChangePasswordMessages.currentPasswordInstruction]: "Enter your current Topcon Customer password",
  [ChangePasswordMessages.currentPasswordLabel]: "Current password",
  [ChangePasswordMessages.newPasswordInstruction]: "Enter your new password",
  [ChangePasswordMessages.newPasswordLabel]: "New password",
  [ChangePasswordMessages.confirmPasswordInstruction]: "Confirm your new password",
  [ChangePasswordMessages.currentPasswordRequired]: "Current password is required",
  [ChangePasswordMessages.newPasswordRequired]: "New password is required",
  [ChangePasswordMessages.confirmPasswordRequired]: "Password confirmation is required",
  [ChangePasswordMessages.newPasswordMinimumLength]: "New password must be at least 6 characters",
  [ChangePasswordMessages.confirmPasswordNotMatch]: "Passwords do not match",
  [ChangePasswordMessages.changePasswordSuccess]: "Password changed successfully",
  [ChangePasswordMessages.changePasswordFailed]: "Failed to change password",
  [ChangePasswordMessages.changePasswordButtonTitle]: "Change password"
};